import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	background: rgba(243, 242, 249, 0.6);
	border-radius: 10px;
	padding: 15px 20px;
	font-weight: 300;
	font-size: 12px;
	line-height: 14px;
	color: #1a1a1a;
`;

export const Alert = () => {
	return <Container>* Coaching guidance is provided for the first month in each plan.</Container>;
};
